/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import {UI} from "../UIGenerator.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Util} from "../Utilities.js";
import OutputListItem from "./OutputList/OutputListItem.jsx";
import OutputList from "./OutputList/OutputList.jsx";
import ElementStatus from "./ElementStatus.jsx";
import DisplayStateHistory from "./DisplayStateHistory.jsx";
import {Volumes} from "../Objects/Volumes.jsx";

class VolumesManagement extends Component {
    constructor() {
        super();
        this.state = {
            allVolumes: []
        }
    }


    async fetchData() {
        let allVolumes = await Database.table("Volumes", "app").getData()
        this.setState({allVolumes: allVolumes.recordset})
    }

    componentDidMount() {
        this.fetchData()
    }


    async editContainer(volume) {
        UI.drawer(Util.unique.newInternalId(), (state, setState, close) => {
            return (<div className={"p-2"}>
                <OutputList>
                    <OutputListItem titel={"indexKey"}>
                        <span>{volume.indexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={"volumeName"}>
                        <span>{volume.volumeName}</span>
                    </OutputListItem>
                    <OutputListItem titel={"serverId"}>
                        <span>{volume.serverId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"volumeId"}>
                        <span>{volume.volumeId}</span>
                    </OutputListItem>
                    <OutputListItem titel={"volumeSize"}>
                        <span>{volume.volumeSize}</span>
                    </OutputListItem>
                    <OutputListItem titel={"status"}>
                        <span>{volume.status}</span>
                    </OutputListItem>
                    <OutputListItem titel={"nodeIndexKey"}>
                        <span>{volume.nodeIndexKey}</span>
                    </OutputListItem>
                    <OutputListItem titel={""}>
                        <ButtonComponent
                            text={"Remove Volume"}
                            onClick={async () => {
                                await Volumes(volume.indexKey).remove()
                                await this.fetchData()
                                close()
                            }}></ButtonComponent>


                    </OutputListItem>
                    <div className={"h-32"}>
                        <DisplayStateHistory name={"Volumes"} elementId={volume.indexKey}/>
                    </div>

                </OutputList>

            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Edit Volume", button: [{
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open()


    }

    render() {
        let {allVolumes} = this.state

        return (
            <div>
                <RowDataTable
                    selectedIndex={this.state.selectedIndex}
                    iconElement={(row) => {
                        return (<div
                            className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                            <DisplayIcon iconName={"Volume"} size={"1.1rem"}/>
                        </div>)
                    }}
                    buttons={(row) => {
                        return <>
                            <ElementStatus name={"Volumes"} elementId={row.indexKey}/>

                            {row?.URL !== undefined && (<>
                                <IconButtonComponent text={`Open`}
                                                     iconName={"IoEyeOutline"}
                                                     onClick={() => {
                                                         let url = "/a/" + row.URL.replace(/^\//g, '')
                                                         // open the page
                                                         UI.page().navigate({
                                                             pathname: url,
                                                         })
                                                     }}/>
                            </>)}

                            <IconButtonComponent text={`Edit `}
                                                 iconName={"IoPencilOutline"}
                                                 onClick={() => {
                                                     UI.page().navigate({
                                                         pathname: "/layout/edit",
                                                         search: '?indexKey=' + row.indexKey,
                                                         state: {data: row}
                                                     })

                                                 }}/>
                        </>

                    }}
                    data={allVolumes.map(item => ({
                        ...item,
                        Name: <>{item.volumeName} </>

                    }))}
                    emptyState={() => {
                        return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                 text={<div className={"w-96 space-y-3"}>
                                                     <TextElement
                                                         textType={"header-lg"}> Keine test mit
                                                         dem Namen: "<span
                                                             className={"italic"}>{this.state.searchinput}</span>"
                                                         gefunden</TextElement>

                                                     <ButtonComponent iconName={"IoAdd"}
                                                                      onClick={() => {
                                                                          //AppActions.layout.newLayout()
                                                                      }}
                                                                      text={`Neue  `}/>
                                                 </div>}/></>)

                    }}
                    progressPending={!this.state.isLoadedComplete}
                    onRowClicked={(data) => {
                        this.editContainer(data)

                    }}
                    onMiddleMouseClick={(data) => {
                    }}
                />

            </div>
        );
    }
}

export default VolumesManagement;